import { TEMPLATE_PLACEHOLDERS } from '../consts';

// Anything in double braces, line breaks included, e.g. `{{firstname}}` or `{{ FirstName }}`
const PLACEHOLDER_PATTERN = /\{\{.*?\}\}/gs;

const KNOWN_PLACEHOLDERS = new Set<string>(Object.values(TEMPLATE_PLACEHOLDERS));

/** The first `{{…}}` in a reply that the API doesn't fill in; `undefined` when every placeholder is known. */
export const findUnknownPlaceholder = (content: string) =>
  content.match(PLACEHOLDER_PATTERN)?.find((placeholder) => !KNOWN_PLACEHOLDERS.has(placeholder));
